module.exports = __webpack_public_path__ + "static/media/google_pay.95f3d7cc.svg";